import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';

import { WkAlfrescoApiService } from '../../../services';
import { INote } from '../model';

@Injectable({
  providedIn: 'root',
})
export class AiUMCService {
  private readonly contentType = ['application/json'];
  constructor(private readonly apiService: WkAlfrescoApiService) {}

  public getGeneratedAIUMCData(queryParams: {
    nodeId: string;
    sectionId: string;
  }): Observable<INote[]> {
    return from(
      this.apiService.callContentClientCustomApi({
        path: 'alfresco/s/wk/hlrp/ai/apollo_umc/lippincott-procedures/update-manager-comments',
        httpMethod: 'POST',
        contentTypes: this.contentType,
        accepts: this.contentType,
        bodyParam: queryParams,
      })
    );
  }
}
